import { Link } from "react-router-dom";
import { Linkedin, Twitter, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/80 mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="text-2xl md:text-3xl font-extrabold tracking-tight text-white">
            STONE SHIRE <span className="text-forest" style={{color:"#8AA795"}}>GROUP</span>
          </div>
          <p className="mt-4 text-white/60 max-w-md">
            One group. Every industry. Built on trust. Diversified across construction, trade, and technology — open to partnerships across any sector.
          </p>
        </div>
        <div>
          <div className="text-sm text-white/50 uppercase tracking-widest mb-4">Explore</div>
          <ul className="space-y-2">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/divisions" className="hover:text-white" data-testid="footer-link-divisions">Divisions</Link></li>
            <li><Link to="/portfolio" className="hover:text-white" data-testid="footer-link-portfolio">Portfolio</Link></li>
            <li><Link to="/partner" className="hover:text-white" data-testid="footer-link-partner">Partner</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-sm text-white/50 uppercase tracking-widest mb-4">Contact</div>
          <a
            href="mailto:info@stoneshire.ca"
            className="block text-white hover:text-white/80"
            data-testid="footer-email"
          >
            info@stoneshire.ca
          </a>
          <div className="text-white/50 mt-1">stoneshire.ca</div>
          <div className="flex gap-4 mt-6">
            <a href="#" aria-label="LinkedIn" className="text-white/60 hover:text-white" data-testid="social-linkedin"><Linkedin size={18} /></a>
            <a href="#" aria-label="Twitter" className="text-white/60 hover:text-white" data-testid="social-twitter"><Twitter size={18} /></a>
            <a href="#" aria-label="Github" className="text-white/60 hover:text-white" data-testid="social-github"><Github size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Stone Shire Group. All rights reserved.</div>
          <div>stoneshire.ca</div>
        </div>
      </div>
    </footer>
  );
}
